import AISparkle from "../../assets/images/AISparkle.svg";
import CSS from "./styles.module.css";

const HeroText = ({ result }) => {
	return (
		<div className={`${CSS.HeroText} ${result === 3 ? CSS.HeroText2 : ""}`}>
			<h1 className={`${CSS.Text} ${result === 3 ? CSS.Text2 : ""}`}>
				{result === 3
					? "Your Job Description is Ready!"
					: "Free AI Job Description Generator"}
				<img src={AISparkle} alt="Free AI Job Description Generator" />
			</h1>
			<font>Create your perfect job description for any role in seconds.</font>
		</div>
	);
};

export default HeroText;
